package com.karyadina.service

import com.karyadina.model.*
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

/**
 * Interface for storing and retrieving Pomodoro data
 */
interface PomodoroStorage {
    fun saveSessions(sessions: List<PomodoroSession>)
    fun loadSessions(): List<PomodoroSession>
    fun saveConfig(config: PomodoroConfig)
    fun loadConfig(): PomodoroConfig
    fun saveStats(stats: PomodoroStats)
    fun loadStats(): PomodoroStats?
}

/**
 * Implementation using generic KeyValueStorage
 * Works across all platforms (Android, Web, Desktop)
 */
class PomodoroStorageImpl(
    private val storage: KeyValueStorage = AppStorage.get()
) : PomodoroStorage {
    
    companion object {
        private const val KEY_SESSIONS = "pomodoro_sessions"
        private const val KEY_CONFIG = "pomodoro_config"
        private const val KEY_STATS = "pomodoro_stats"
    }
    
    override fun saveSessions(sessions: List<PomodoroSession>) {
        storage.saveJson(KEY_SESSIONS, sessions)
    }
    
    override fun loadSessions(): List<PomodoroSession> {
        return storage.loadJson<List<PomodoroSession>>(KEY_SESSIONS) ?: emptyList()
    }
    
    override fun saveConfig(config: PomodoroConfig) {
        storage.saveJson(KEY_CONFIG, config)
    }
    
    override fun loadConfig(): PomodoroConfig {
        return storage.loadJson<PomodoroConfig>(KEY_CONFIG) ?: PomodoroConfig()
    }
    
    override fun saveStats(stats: PomodoroStats) {
        storage.saveJson(KEY_STATS, stats)
    }
    
    override fun loadStats(): PomodoroStats? {
        return storage.loadJson<PomodoroStats>(KEY_STATS)
    }
}
